webpackJsonp([213534597649335],{

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(16);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(15);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(64);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(35);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _TagIcon = __webpack_require__(432);
	
	var _TagIcon2 = _interopRequireDefault(_TagIcon);
	
	var _LocationIcon = __webpack_require__(431);
	
	var _LocationIcon2 = _interopRequireDefault(_LocationIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GridItem = function GridItem(_ref) {
	    var uid = _ref.uid,
	        sizes = _ref.sizes,
	        alt = _ref.alt,
	        title = _ref.title,
	        subtitle = _ref.subtitle,
	        date = _ref.date,
	        words = _ref.words,
	        category = _ref.category,
	        location = _ref.location;
	    return _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	            'div',
	            { className: 'blog-index__block', key: uid },
	            _react2.default.createElement(
	                'div',
	                { className: 'block-text' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'date' },
	                    date,
	                    ' \xB7 ',
	                    words,
	                    ' words'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: uid },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'block-title' },
	                            ' ',
	                            title,
	                            ' '
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'block-tags' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'category' },
	                            _react2.default.createElement(_TagIcon2.default, { className: 'icon' }),
	                            ' ',
	                            category,
	                            ' '
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'category' },
	                            ' ',
	                            _react2.default.createElement(_LocationIcon2.default, { className: 'icon' }),
	                            ' ',
	                            location
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-image' },
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: uid },
	                        _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes, alt: alt })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-description' },
	                    subtitle
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'block-cta' },
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: uid },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'btn' },
	                            ' Read more'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = GridItem;
	
	
	GridItem.propTypes = {
	    uid: _propTypes2.default.string.isRequired,
	    sizes: _propTypes2.default.any.isRequired,
	    alt: _propTypes2.default.string.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    date: _propTypes2.default.string.isRequired,
	    subtitle: _propTypes2.default.string.isRequired,
	    words: _propTypes2.default.string.isRequired,
	    category: _propTypes2.default.string.isRequired,
	    location: _propTypes2.default.string.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function LocationIcon (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Workplaces-Homepage","transform":"translate(-1002.000000, -210.000000)","fill":"#000000","fillRule":"nonzero"},React.createElement("g",{"id":"Company-/-Wonder","transform":"translate(170.000000, 180.000000)"},React.createElement("g",{"id":"Meta"},React.createElement("g",{"id":"Location","transform":"translate(832.000000, 30.000000)"},React.createElement("g",{"id":"iconmonstr-location-1"},React.createElement("path",{"d":"M6.66666667,0 C3.16833333,0 0,2.83583333 0,6.335 C0,9.83333333 2.89083333,14.01 6.66666667,20 C10.4425,14.01 13.3333333,9.83333333 13.3333333,6.335 C13.3333333,2.83583333 10.1658333,0 6.66666667,0 Z M6.66666667,9.16666667 C5.28583333,9.16666667 4.16666667,8.0475 4.16666667,6.66666667 C4.16666667,5.28583333 5.28583333,4.16666667 6.66666667,4.16666667 C8.0475,4.16666667 9.16666667,5.28583333 9.16666667,6.66666667 C9.16666667,8.0475 8.0475,9.16666667 6.66666667,9.16666667 Z","id":"Shape"}))))))));
	}
	
	LocationIcon.defaultProps = {"width":"14px","height":"20px","viewBox":"0 0 14 20","version":"1.1","xlinkHref":"http://www.w3.org/1999/xlink"};
	
	module.exports = LocationIcon;
	
	LocationIcon.default = LocationIcon;


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function TagIcon (props) {
	    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Workplaces-Homepage","transform":"translate(-786.000000, -212.000000)","fill":"#000000"},React.createElement("g",{"id":"Company-/-Wonder","transform":"translate(170.000000, 180.000000)"},React.createElement("g",{"id":"Meta"},React.createElement("g",{"id":"Industry","transform":"translate(616.000000, 30.000000)"},React.createElement("path",{"d":"M9,5.6 L9,2 L0,2 L0,18.2 L18,18.2 L18,5.6 L9,5.6 Z M3.6,16.4 L1.8,16.4 L1.8,14.6 L3.6,14.6 L3.6,16.4 Z M3.6,12.8 L1.8,12.8 L1.8,11 L3.6,11 L3.6,12.8 Z M3.6,9.2 L1.8,9.2 L1.8,7.4 L3.6,7.4 L3.6,9.2 Z M3.6,5.6 L1.8,5.6 L1.8,3.8 L3.6,3.8 L3.6,5.6 Z M7.2,16.4 L5.4,16.4 L5.4,14.6 L7.2,14.6 L7.2,16.4 Z M7.2,12.8 L5.4,12.8 L5.4,11 L7.2,11 L7.2,12.8 Z M7.2,9.2 L5.4,9.2 L5.4,7.4 L7.2,7.4 L7.2,9.2 Z M7.2,5.6 L5.4,5.6 L5.4,3.8 L7.2,3.8 L7.2,5.6 Z M16.2,16.4 L9,16.4 L9,14.6 L10.8,14.6 L10.8,12.8 L9,12.8 L9,11 L10.8,11 L10.8,9.2 L9,9.2 L9,7.4 L16.2,7.4 L16.2,16.4 Z M14.4,9.2 L12.6,9.2 L12.6,11 L14.4,11 L14.4,9.2 Z M14.4,12.8 L12.6,12.8 L12.6,14.6 L14.4,14.6 L14.4,12.8 Z","id":"Shape"})))))));
	}
	
	TagIcon.defaultProps = {"width":"18px","height":"17px","viewBox":"0 0 18 17","version":"1.1","xlinkHref":"http://www.w3.org/1999/xlink"};
	
	module.exports = TagIcon;
	
	TagIcon.default = TagIcon;


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _GridItem = __webpack_require__(203);
	
	var _GridItem2 = _interopRequireDefault(_GridItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var edges = _ref.data.caseStudies.edges;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-index' },
	      _react2.default.createElement(
	        'div',
	        { className: 'blog-index__wrapper' },
	        edges.map(function (c) {
	          return _react2.default.createElement(_GridItem2.default, {
	            uid: c.node.uid,
	            key: c.node.uid,
	            sizes: c.node.data.header_image.localFile.childImageSharp.sizes,
	            alt: c.node.data.title.text,
	            title: c.node.data.title.text,
	            subtitle: c.node.data.subtitle.text,
	            words: c.node.data.words.text,
	            category: c.node.data.category.text,
	            location: c.node.data.location.text,
	            date: c.node.data.date
	          });
	        })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.shape({
	    caseStudies: _propTypes2.default.shape({
	      edges: _propTypes2.default.array.isRequired
	    })
	  }).isRequired
	};
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-7c7947be42ba046ed915.js